export default "__VITE_ASSET__DzJTgizI__"